// extracted by mini-css-extract-plugin
export default {"small":"small-n8_K"};